import DOMPurify from "dompurify";

interface Props {
  title: string;
  body: string;
}

export const RitualPerkTermsModal: React.FC<Props> = ({ title, body }) => {
  // Sanitize the raw HTML
  const sanitizedHTML = DOMPurify.sanitize(body || "");

  return (
    <div>
      <h2>{title}</h2>
      <div
        dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
      />
    </div>
  );
};

export default RitualPerkTermsModal;
